import { ActionFiltersController } from "./action-filters.component.controller"
import { USER_SESSION_SERVICE_NAME } from "../../../services/user-session"
import { $SCOPE_SERVICE_NAME } from "../../../services/system"

//#region Asset Imports

import * as TEMPLATE from './action-filters.tpl.html'
import './action-filters.scss'

//#endregion

export const COMPONENT_NAME: string = 'actionFilters'

export class ActionFiltersComponent {

    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        ActionFiltersController]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}